"use client"
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Dropdown,
} from '@quintoandar-tokko/jopijs'
import { setCalendarData } from '@/store/slices/components/calendar/CalendarSlice';
import { getLocalGMT } from '../utils/dates';
import Trans from '@/components/shared/Trans'
import translations from './calendarTimezoneDropdown.trans.json'
import style from './calendarTimezoneDropdown.module.scss'

export default function CalendarTimezoneDropdown () {
  const calendar = useSelector(state => state.CalendarSlice)
  const dispatch = useDispatch()
  const timezones = [
    { id: 1, name: Trans(translations, "Local"), value: getLocalGMT() },
    { id: 2, name: Trans(translations, "FromTheProperty"), value: calendar.property.gmt },
  ]

  useEffect(() => {
    const timezone = timezones[0]
    dispatch(setCalendarData({ key: 'visit', subkey: 'timezone', value: timezone }))
  }, [])

  const handleChangeTimezone = (timezone) => {
    dispatch(setCalendarData({ key: 'visit', subkey: 'timezone', value: timezone }))
  }

  const renderDropdownButtonText = () => (
    <Box className={style.ddButtonTextWrapper}>
      <Box as="p" className={style.ddButtonLabel}>{Trans(translations, "TimeZone")}:</Box>
      <Box as="p" className={style.ddButtonValue}>
        {calendar.visit.timezone.name} {calendar.visit.timezone.value}
      </Box>
    </Box>
  )

  // TODO: remove it post MVP
  return null

  return (
    <Dropdown className={style.dd}>
      <Dropdown.Button
        className={style.ddButton}
        type="button"
        variant='dropdownTransparent'
        text={renderDropdownButtonText()}
      />
      <Dropdown.Items className={style.ddItems} clickClose>
        {timezones.map((timezone) => (
          <Dropdown.Default
            key={timezone.id}
            ellipsis
            onClick={() => handleChangeTimezone(timezone)}
          >
            {`${timezone.name} ${timezone.value}`}
          </Dropdown.Default>
        ))}
      </Dropdown.Items>
    </Dropdown>
  )
}
